var app = angular.module("leonardo");

var DeleteUnitsController = function($scope, $state, $rootScope, ngDialog, FilterService) {


  $scope.unitDelete = $state.current.unitDelete;

  $scope.showDeleteDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/unit/delete-units.html',
      controller: 'DeleteUnitDialog',
      data: {
        filters: {
          account: FilterService.getFilter('account_reports'),
          managed_by: FilterService.getFilter('managed_by_reports'),
          group: FilterService.getFilter('group_reports'),
          portfolio: FilterService.getFilter('portfolio_reports'),
          property: FilterService.getFilter('property_reports'),
          number__icontains: FilterService.getFilter('unit_number_search'),
          building__icontains: FilterService.getFilter('unit_building_search')
        }
      }
    }).then(function () {
      $rootScope.$broadcast('filter-selection:updated');
    });
  };

  $scope.showUnDeleteDialog = function() {
    ngDialog.openConfirm({
      template: 'views/templates/dialog/unit/undelete-units.html',
      controller: 'DeleteUnitDialog',
      data: {
        filters: {
          account: FilterService.getFilter('account_reports'),
          managed_by: FilterService.getFilter('managed_by_reports'),
          group: FilterService.getFilter('group_reports'),
          portfolio: FilterService.getFilter('portfolio_reports'),
          property: FilterService.getFilter('property_reports'),
          number__icontains: FilterService.getFilter('unit_number_search'),
          building__icontains: FilterService.getFilter('unit_building_search')
        }
      }
    }).then(function () {
      $rootScope.$broadcast('filter-selection:updated');
    }, function () {
      return;
    });
  };

};

app.controller('DeleteUnitsController', ['$scope', '$state', '$rootScope', 'ngDialog', 'FilterService', DeleteUnitsController]);
